import styled, { css } from "styled-components";
import { Button, Layout } from "antd";
import { isMobile } from "react-device-detect";
import {
  FONT_SIZE,
  LAYOUT,
  FONT_WEIGHT,
  media,
} from "config/theme/constants";

export const Sider = styled(Layout.Sider)`
  position: fixed;
  overflow: visible;
  left: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;
  display: grid;

  .ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
    border-inline-end: none;
  }

  color: var(--text-secondary-color);

  @media only screen and ${media.md} {
    right: unset;
    left: 0;
  }

  @media only screen and ${media.xl} {
    position: unset;
  }
  .scrollerbars {
    height: calc(100% - 70px) !important;
  }
`;

export const CollapseButton = styled(Button)<{ $isCollapsed: boolean }>`
  background: var(--collapse-background-color);
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  position: absolute;
  right: 0.5rem;

  ${(props) =>
    props.$isCollapsed &&
    css`
      right: -1rem;
    `}

  color: var(--text-secondary-color);

  &:hover {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }

  &:focus {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }
`;

export const SiderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  height: calc(100vh - ${LAYOUT.mobile.headerHeight});
  display: grid;

  @media only screen and ${media.md} {
    height: calc(100vh - ${LAYOUT.desktop.headerHeight});
  }
`;

export const SiderLogoLink = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
`;

export const SiderLogoDiv = styled.div`
  height: ${isMobile ? "2rem" : LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and ${media.md} {
    height: ${LAYOUT.desktop.headerHeight};
    padding-top: ${LAYOUT.desktop.paddingVertical};
    padding-bottom: ${LAYOUT.desktop.paddingVertical};
  }
`;

export const BrandSpan = styled.span`
  margin: 0 1rem;
  font-weight: ${FONT_WEIGHT.bold};
  font-size: ${FONT_SIZE.lg};
  color: var(--white);
`;
